import { useCallback, useState } from 'react';

type PendingReset = { compositeId: string; presenceId?: string } | null;

export function useResetConfirmation() {
  const [pendingReset, setPendingReset] = useState<PendingReset>(null);

  const requestResetAll = useCallback((compositeId: string) => {
    setPendingReset({ compositeId });
  }, []);

  const requestResetSupport = useCallback((compositeId: string, presenceId: string) => {
    setPendingReset({ compositeId, presenceId });
  }, []);

  const cancelReset = useCallback(() => setPendingReset(null), []);

  return { pendingReset, requestResetAll, requestResetSupport, cancelReset };
}
